const nl: { [key: string]: string } = {
    //
};

export default nl;
